import { FileDownloader } from '@core/helpers';
import { FileTypes } from '@core/helpers/enums';
import * as api from './api';
import { OutOfMenu } from './models';

export const outOfMenuRequest = async (context, {
  posGuid, startDate, endDate, outMenuTitle
}) => {
  const response = await api.outOfMenuRequest(posGuid, startDate, endDate);
  response.data.title = outMenuTitle;
  return OutOfMenu.toInstance(response.data);
};

export const exportPriceChangesRequest = async (context, { posGuid, startDate, endDate }) => {
  const response = await api.exportPriceChangesRequest(posGuid, startDate, endDate);
  const name = `price_changes_${startDate}_${endDate}.csv`;
  FileDownloader.downloadFile(FileTypes.CSV, response.data, name);
};
